const LoadingComponent = ({ isLoading, error }) => {
  // Handle the loading state
  if (isLoading) {
    return <div />;
  } else if (error) {
    console.error(error);
    return <div>error</div>;
  } else {
    return null;
  }
};
export default LoadingComponent;



// WEBPACK FOOTER //
// ./src/scripts/components/LoadingComponent/index.js